import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import { BulkDeleteSnippetModalComponent } from "./BulkDeleteSnippetModalComponent";

const BulkDeleteSnippetModal = ModalManager.create(
  ({
    selectedIds,
    setSelectedIds,
    onDelete,
  }: {
    selectedIds: number[];
    setSelectedIds: (ids: number[]) => void;
    onDelete?: () => void;
  }) => (
    <BulkDeleteSnippetModalComponent
      selectedIds={selectedIds}
      setSelectedIds={setSelectedIds}
      onDelete={onDelete}
    />
  ),
);

export const useBulkDeleteSnippetModal = () => useModal(BulkDeleteSnippetModal);
